module.exports = __webpack_public_path__ + "static/media/blog.bde4a0a2.jpg";